
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import config from "@/config";
import { pageViewUnit } from "@/config";
@Component({
  name: "HomeSearch",
  components: {},
})
export default class HomeSearch extends Vue {
  @Getter("company") private company!: string;
  @Getter("cityId") private cityId!: string;
  @Getter("city") private city!: any;
  @Getter("cityName") private cityName!: string;
  @Getter("role") private role!: string;
  @Action("policy/searchPolicyData") private getMatchList: any;
  @Getter("id") private id!: any;
  @Action("policy/getSearchList") private getSearchList: any;
  @Action("policy/searchAllPolicy") private searchAllPolicy: any;
  @Action("getSearchList") private getAllSearchListData: any;
  pageViewUnit = pageViewUnit;
  isKunMing: any = config.isKunMing;
  // private toMatch({ originalAddress }: any, column?: any, e?: any) {
  // 	if (!originalAddress) {
  // 		return;
  // 	}
  // 	this.$router.push({
  // 		path: `/${this.isKunMing ? "kunming" : ""}detail/match`,
  // 		query: {
  // 			url: originalAddress
  // 		}
  // 	});
  // 	// this.isDialog = true;
  // }
  private toMatch({ id, declareItemId }: any) {
    this.$router.push({
      path: "/detail/apply",
      query: {
        projectId: declareItemId,
        directionId: id,
      },
    });
  }

  btnList: any = [
    {
      label: "政策匹配",
      placeholder: "请输入企业名称 进行政策匹配",
    },
    {
      label: "政策查询",
      placeholder: "请输入政策、项目、通知、公告标题进行搜索",
    },
  ];
  keyTitle: string = "热搜词";
  activeBtn: any = 0;
  restaurants = [];
  matchList: any = [];
  searchValue: any = "";
  searchText = "匹配";
  policyData: any = [];
  companyData: any = [];
  hotWord: Array<string> = [];
  enterpriseWord: any = [];
  policyWord: any = [];
  created() {
    this.getData();
  }
  getData() {
    this.getHotWord();
    this.getRecomData();
  }
  async getAllSearchList(search: any) {
    const options = {
      cityName: this.cityName,
      corporateName: search,
    };
    const res = await this.getAllSearchListData(options);
    return res;
  }
  getRecomData() {
    const unitList = ["unit", "declare"];
    let options: any = {
      pageNumber: 1,
      pageSize: 3,
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
    };
    if (!this.city.locationAddressCode) {
      options.addressCode = this.city.id;
    }

    this.getMatchList(options)
      .then((res: any) => {
        const { code, result, msg } = res;
        if (code === 200 && result) {
          this.matchList = result.records;
          console.log(this.matchList, 9999);
        }
      })
      .catch((err: any) => err);
  }
  getHotWord() {
    this.getSearchList()
      .then((res: any) => {
        const { code, result, msg } = res;
        if (code === 200 && result) {
          console.log(result);
          if (result.length > 3) {
            result.length = 3;
          }
          this.policyWord = result;
          this.enterpriseWord = [];
          if (this.activeBtn === 0) {
            this.hotWord = [];
          } else {
            this.hotWord = result;
          }
        }
      })
      .catch((err: any) => err);
  }
  getSearchWord() {
    this.$store.dispatch("policy/getSearchWord").then((data: any) => {
      if (data) {
        this.policyData = data.map((item: any) => {
          return { value: item };
        });
      }
    });
  }
  onclick(e: number) {
    this.activeBtn = e;
    this.searchValue = "";
    if (e === 0) {
      this.restaurants = this.companyData;
      this.searchText = "匹配";
      this.hotWord = this.enterpriseWord;
      // this.getHotWord();
    } else {
      this.restaurants = this.policyData;
      this.searchText = "搜索";
      this.hotWord = this.policyWord;
    }
  }
  async querySearch(queryString: any, cb: any) {
    let restaurants: any = [];
    if (queryString && this.activeBtn === 0) {
      const originRestaurants = await this.getAllSearchList(queryString);
      restaurants = originRestaurants;
      this.restaurants = restaurants;
    } else if (queryString && this.activeBtn === 1) {
      const originRestaurants = await this.searchAllPolicy(queryString);
      restaurants = originRestaurants.map((item: any) => {
        return { value: item, id: item };
      });
      this.restaurants = restaurants;
    }
    const results = queryString
      ? restaurants.filter((item: any) => item.value.indexOf(queryString) >= 0)
      : restaurants;

    // 调用 callback 返回建议列表的数据
    cb(results);
  }
  createFilter(queryString: any) {
    return (restaurant: any) => {
      return (
        restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      );
    };
  }
  search(word: any) {
    console.log(word);
    this.searchValue = word;
    this.searchData(word);
  }
  searchData(word: any) {
    if (!this.searchValue && !word) {
      return this.$message.error("请填写匹配内容");
    }
    let id;
    if (this.activeBtn === 0) {
      // if(!this.id) {
      //   this.$router.push({path: '/login'});
      //   return this.$message.warning("请先登录!")
      // }
      const filterRes = this.restaurants.find((item: any) => {
        return item.value === this.searchValue;
      });
      if (!filterRes) {
        return this.$message.warning("无法匹配该企业");
      }
      this.$router.push({
        path: this.isKunMing ? "/kunmingdetail/company" : "/pcm/company",
        query: { params: this.searchValue || word },
      });
    } else if (this.activeBtn === 1) {
      const filterRes = this.restaurants.find((item: any) => {
        return item.value === this.searchValue;
      });
      // if(!filterRes) {
      //   return this.$message.warning("无法匹配该政策")
      // }
      this.$router.push({
        path: this.isKunMing ? "/kunmingdetail/allpolicy" : "/pcm/allpolicy",
        query: { params: this.searchValue || word },
      });
      // id = this.policyData.find((item: any) => item.value === this.searchValue).id;
      // if (id) {
      //   this.$router.push({
      //     path: "/user/keyword",
      //     query: {search: id},
      //   });
      // } else {
      //   return this.$message.error('请在选择后不要改动搜索信息')
      // }
    }
  }
  handleSelect() {}
  @Watch("cityId")
  handleCityChange() {
    this.getRecomData();
  }
}
